import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import Documento from "model/documentos/Documento";
import DocumentoAlterarAlertaVencimento from "model/documentos/DocumentoAlterarAlertaVencimento";
import DocumentoAlterarDadosGerais from "model/documentos/DocumentoAlterarDadosGerais";
import DocumentoAlterarValidade from "model/documentos/DocumentoAlterarValidade";
import DocumentoAssociacao from "model/documentos/DocumentoAssociacao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class DocumentoService implements BaseServiceCadastros<Documento> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/documento/pesquisar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Documento>((resolve, reject): void => {
            api
                .get(`/documento/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(documento: Documento | FormData) {
        return new Promise<Documento>((resolve, reject): void => {
            if (documento instanceof FormData) {
                apiFile
                    .post(`/documento/incluirComArquivo`, documento)
                    .then(response => resolve(response.data))
                    .catch((err: AxiosError) => reject(err.response));
                return;
            }
            let url = `/documento/incluir`;
            api
                .post(url, JSON.stringify(documento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(documento: Documento) {
        return new Promise<Documento>((resolve, reject): void => {
            api
                .put(`/documento/editar`, JSON.stringify(documento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editarControles(documento: Documento) {
        return new Promise<Documento>((resolve, reject): void => {
            api
                .put(`/documento/editarControles`, JSON.stringify(documento))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/documento/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterarValidade(dados: DocumentoAlterarValidade) {
        return new Promise<Documento>((resolve, reject): void => {
            api
                .put(`/documento/alterarValidade`, JSON.stringify(dados))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterarDadosGerais(dados: DocumentoAlterarDadosGerais) {
        return new Promise<Documento>((resolve, reject): void => {
            api
                .put(`/documento/alterarDadosGerais`, JSON.stringify(dados))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterarAlertaVencimento(dados: DocumentoAlterarAlertaVencimento) {
        return new Promise<Documento>((resolve, reject): void => {
            api
                .put(`/documento/alterarAlertaVencimento`, JSON.stringify(dados))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(idCategoria: number) {
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/documento/proximoCodigo/${idCategoria}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    categorias() {
        return new Promise<CategoriaDocumento[]>((resolve, reject): void => {
            api
                .get(`/documento/categorias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/documento/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    documentos() {
        return new Promise<Documento[]>((resolve, reject): void => {
            api
                .get(`/documento/documentos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    documentosRelacionados(id: number) {
        return new Promise<DocumentoAssociacao[]>((resolve, reject): void => {
            api
                .get(`/documento/documentosRelacionados/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }


    getCopiaControlada = (id: number): Promise<Blob> => {
        return new Promise<Blob>((resolve, reject): void => {
            let url = `/documento/copiaControlada/${id}`;
            api
                .get(url, { responseType: 'blob' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {
                    reject(err.response)
                });
        });
    }

    incluirDocumentoRelacionado(documentoAssociacao: DocumentoAssociacao) {
        return new Promise<DocumentoAssociacao>((resolve, reject): void => {
            let url = `/documento/incluirDocumentoRelacionado`;
            api
                .post(url, JSON.stringify(documentoAssociacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluirDocumentoRelacionado(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/documento/excluirDocumentoRelacionado/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListStatus() {
        return [
            { label: "Em Elaboração", value: "EM_ELABORACAO" },
            { label: "Em Revisão", value: "EM_REVISAO" },
            { label: "Aguardando Aprovação", value: "AGUARDANDO_APROVACAO" },
            { label: "Aguardando Publicação", value: "AGUARDANDO_PUBLICACAO" },
            { label: "Publicado", value: "PUBLICADO" },
            { label: "Obsoleto", value: "OBSOLETO" },
            { label: "Removido", value: "REMOVIDO" },
            { label: "Apagado", value: "APAGADO" }
        ]
    }

    getListStatusFilter() {
        return [
            { label: "Em Elaboração", value: "EE" },
            { label: "Em Revisão", value: "ER" },
            { label: "Aguardando Aprovação", value: "AA" },
            { label: "Aguardando Publicação", value: "AP" },
            { label: "Publicado", value: "P" },
            { label: "Obsoleto", value: "O" },
            { label: "Removido", value: "R" },
            { label: "Apagado", value: "A" }
        ]
    }

    getStatus(status: string) {
        const statusList = this.getListStatus();
        const foundStatus = statusList.find(s => s.value === status);
        return foundStatus ? foundStatus.label : "Desconhecido";

    }

    getStatusColor(status: string) {
        switch (status) {
            case 'EM_ELABORACAO':
                return '#FDED00';
            case 'EM_REVISAO':
                return '#FDED00';
            case 'AGUARDANDO_APROVACAO':
                return '#FDED00';
            case 'AGUARDANDO_PUBLICACAO':
                return '#FDED00';
            case 'PUBLICADO':
                return '#00DD00';
            case 'APAGADO':
                return '#FF0000';
            case 'REMOVIDO':
                return '#FF0000';
            default:
                return '#FFFFFF';
        }
    }

}

export default DocumentoService;
